module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-list"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    ref: "search",
    staticStyle: {
      "margin": "6px 8px"
    },
    attrs: {
      "filled": "",
      "dense": "",
      "rounded": "",
      "placeholder": "Search...",
      "hide-details": ""
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1",
      "overflow-y": "auto"
    }
  }, [_c('v-list-item-group', [_vm._t("top"), _vm._v(" "), _vm._l((_vm.itemsList), function(item, idx) {
    return _c('v-list-item', {
      key: idx,
      class: {
        selected: _vm.isSelected(item)
      },
      attrs: {
        "input-value": _vm.value && item._id == _vm.value._id
      },
      on: {
        "click": function($event) {
          return _vm.select(item)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                        " + _vm._s(item.title || item.name || item.text) + "\n                    ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                        " + _vm._s(item.value || item.details || item.text) + "\n                    ")])], 1)], 1)
  }), _vm._v(" "), _vm._t("bottom")], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03293a14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/lists/ListList.vue
// module id = 2429
// module chunks = 1